export const BACKUP_CODES_STATUS_SUMMARY_TEST_IDS = {
  root: 'backup-codes-status-summary',
  codesRemaining: 'backup-codes-status-summary-remaining',
  generatedOn: 'backup-codes-status-summary-generated-on',
  generateButton: 'backup-codes-status-summary-generate-button',
} as const;
